<template>
  <div>
    <el-row>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span class="info-label">供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span class="info-label">送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span class="info-label">地址</span>：{{ titleData[0].GYS_ADDRESS }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span class="info-label">订单ID</span>：{{ orderId }}</li>
          <li><span class="info-label">订单总金额</span>：{{ titleData[0].REAL_TOTAL_GYS_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column label="产品" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订单数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.REAL_COUNT" :placeholder="scope.row.PRODUCT_COUNT"
                @focus="getColumnRow(scope.row)" @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="验收总价">
            <template slot-scope="scope">
              {{ setTotalFee(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="不含税验收总价"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="showUploadBatch(scope.row)" icon="el-icon-upload">上传批次报告
              </el-button><br>
              <el-button v-show="scope.row.BATCH_REPORT_ID !== 0" size="small" type="text"
                @click="downloadBatch(scope.row.BATCH_REPORT_ID)" icon="el-icon-download">
                查询批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-button type="primary" :disabled="isDisabled" @click="__confirm()" :loading="loading" style="float: right;">
        全部确认
      </el-button>
      <el-button @click="openBatchUploadDialog" style="float: right; margin-right: 10px;">
        批量上传批次报告
      </el-button>
    </el-row>
    <el-dialog title="提示" :visible.sync="tableVisible" width="50%" center :close-on-click-modal="false">
      <p style="color: red">下列为数量产生变动的产品，请再次确认</p>
      <el-table :data="arrData" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订单数量"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="changSubmit" :loading="loading1">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传批次报告" center :visible.sync="uploadBatchFormVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" ref="uploadBatchForm" :model="uploadBatchForm" style="padding-left: 30px;"
        label-width="120px">
        <el-form-item label="送检单位：">
          <el-input v-model="uploadBatchForm.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="送检机构：">
          <el-input v-model="uploadBatchForm.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="上传批次报告：">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" name="qualification" multiple
            :file-list="fileList" :data="上传批次报告参数">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('uploadBatchForm')">取 消</el-button>
        <el-button size="small" @click="$uploadBatch()" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量上传批次报告" center :visible.sync="batchUploadBatchVisible" width="500px"
      :close-on-click-modal="false">
      <el-form ref="batchUploadBatchForm" :model="batchUploadBatchForm" style="padding-left: 30px;" label-width="120px">
        <el-form-item label="送检单位：">
          <el-input v-model="batchUploadBatchForm.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="送检机构：">
          <el-input v-model="batchUploadBatchForm.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="文件：">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="batchUploadHandleSuccess" :on-remove="batchUploadHandleRemove" name="qualification"
            multiple :file-list="fileList" :data="上传批次报告参数">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('batchUploadBatchForm')">取 消</el-button>
        <el-button size="small" @click="batchUploadBatchReport()" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查询批次报告" center :visible.sync="查询批次报告模态框" width="500px" :close-on-click-modal="false">
      <el-form ref="查询批次报告表单" :model="查询批次报告表单" style="padding-left: 30px;" label-width="120px">
        <el-form-item label="送检单位：">
          <el-input v-model="查询批次报告表单.SUBMIT_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="送检机构：">
          <el-input v-model="查询批次报告表单.TEST_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="文件：">
          <el-button size="small" type="text" @click="下载资质()">下载资质</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="查询批次报告模态框 = false">取 消</el-button>
        <el-button size="small" @click="batchUploadBatchReport" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  historyOrderDetailFun, checkConfirmOrderFun, uploadBatch, downloadBatchReport, batchUploadBatchReport,
} from '@/assets/api/shopOrderManage';

export default {
  data () {
    return {
      上传批次报告参数: {
        remainName: 1,
      },
      查询批次报告表单: {},
      查询批次报告模态框: false,
      fromName: ['shopConfirmOrderList'],
      toName: [],
      loading: false,
      loading1: false,
      tableData: [],
      productArray: [],
      titleData: [{
        SUPPLIER_NAME: '',
        SEND_DAY: '',
        ORDER_CODE: '',
        TOTAL_GYS_FEE: '',
      }],
      isDisabled: false,
      tableVisible: false,
      productID: 0,
      changeProducts: [],
      TOTAL_FEE: 0,
      TC_ID: sessionStorage.getItem('companyId'),
      orderId: sessionStorage.getItem('orderId'),
      OTYPE: 0,
      arrData: [],
      currentUnit: '',
      uploadBatchFormVisible: false,
      uploadBatchForm: {},
      batchUploadBatchVisible: false,
      batchUploadBatchForm: {},
      loading2: false,
      fileList: [],
      uploadDetailList: [],
    };
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单进入订单验收', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.getOrderDetailList();
      }
    });
  },
  methods: {
    // ------------------------------------拉取数据
    getOrderDetailList () {
      // 刷新前缓存用户修改的实收数量，避免被接口数据覆盖
      const realCountCache = {};
      this.tableData.forEach((item) => {
        realCountCache[item.ID] = item.REAL_COUNT;
      });
      const params = {
        ID: Number(sessionStorage.getItem('orderId')),
      };
      historyOrderDetailFun(params).then((result) => {
        if (result[0].list.length) {
          this.tableData = result[0].list.map((item) => Object.assign(item, { REAL_COUNT: Number(item.PRODUCT_COUNT), BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }));
          // 恢复用户已修改的实收数量
          this.tableData.forEach((item) => {
            if (realCountCache[item.ID] !== undefined && String(realCountCache[item.ID]) !== String(item.PRODUCT_COUNT)) {
              item.REAL_COUNT = realCountCache[item.ID];
              item.TOTAL_FEE = Math.round(Number(realCountCache[item.ID]) * Number(item.REAL_PRICE) * 100) / 100;
            }
          });
        }
        this.titleData = result[0].title;
        this.productArray = this.tableData.map((item) => ({ REAL_COUNT: Number(item.PRODUCT_COUNT), PRODUCT_COUNT: Number(item.PRODUCT_COUNT), ORDER_DETAIL_ID: item.ID }));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getColumnRow (row) {
      this.productID = row.ID;
      this.currentUnit = row.TYPE_UNIT;
    },
    // ---------------------------设置当前产品的实收数量
    currentActualNumber (row) {
      return row.PRODUCT_COUNT;
    },
    // ----------------------------改变实收数量触发
    setActualNumber (row) {
      row.TOTAL_FEE = Math.round(row.REAL_COUNT * Number(row.REAL_PRICE) * 100) / 100;
    },
    // -------------------------------准备改变的数据
    prepareChangeData (count) {
      count = Number(count);
      const data = this.tableData.filter((item) => item.ID === this.productID);
      this.changeProducts.push(...data);
      for (let i = 0, len = this.changeProducts.length; i < len; i++) {
        const item = this.changeProducts[i];
        if (item.ID === this.productID) {
          item.REAL_COUNT = count;
          item.TOTAL_FEE = Math.round(count * Number(item.REAL_PRICE) * 100) / 100;
          break;
        }
      }
    },
    // -----------------------------------设置验收总价
    setTotalFee (row) {
      return row.TOTAL_FEE.toFixed(2);
    },
    // -----------------------------------全部确认
    __confirm () {
      if (this.changeProducts.length !== 0) {
        this.arrData = this.changeProducts.filter((ele, index, self) => self.indexOf(ele) === index);
        this.tableVisible = true;
      } else {
        this.changSubmit();
      }
    },
    // ------------------------------------确认按钮
    changSubmit () {
      this.loading = true;
      const submitArr = this.tableData.map((item, index) => ({
        ORDER_DETAIL_ID: Number(item.ID), PRODUCT_CODE: item.PRODUCT_CODE, NEW_COUNT: Number(item.REAL_COUNT), PRODUCT_FEE: Number(item.TOTAL_FEE),
      }));
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        PRODUCT_ARRAY: submitArr,
      };
      this.loading1 = true;
      checkConfirmOrderFun(params).then((result) => {
        if (result) {
          this.$message.show({ text: '确认成功', type: 'success' });
          this.$router.push({ name: 'shopConfirmOrderList' });
          this.loading = false;
          this.loading1 = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
        this.loading1 = false;
      });
    },
    close () {
      this.tableVisible = false;
      this.fileList = [];
      this.file_name = '';
      this.uploadBatchFormVisible = false;
      this.batchUploadBatchVisible = false;
    },
    // 上传批次报告
    showUploadBatch (row) {
      this.uploadBatchFormVisible = true;
      this.uploadBatchForm = { ...row, DETAIL_ID: row.ID };
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
      this.file_name = '';
    },
    $uploadBatch () {
      this.loading2 = true;
      const params = {
        DETAIL_ID: this.uploadBatchForm.DETAIL_ID,
        PRODUCT_CODE: this.uploadBatchForm.PRODUCT_CODE,
        FILE_URL: this.fileList.map((item) => item.response.file_name),
        SUBMIT_UNIT: this.uploadBatchForm.SUBMIT_UNIT,
        TEST_UNIT: this.uploadBatchForm.TEST_UNIT,
      };
      uploadBatch(params).then((result) => {
        this.$message.show({ text: '上传批次报告成功', type: 'success' });
        this.loading2 = false;
        this.uploadBatchFormVisible = false;
        this.uploadBatchForm = {};
        this.fileList = [];
        this.file_name = '';
        this.getOrderDetailList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading2 = false;
      });
    },

    downloadBatch (BATCH_REPORT_ID) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        this.查询批次报告模态框 = true;
        this.查询批次报告表单 = { ...result[0] };
        this.查询批次报告表单.FILE_PATH = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange (val) {
      this.uploadDetailList = val.map((item) => item.ID);
    },
    batchUploadHandleSuccess (response, file, fileList) {
      this.fileList = fileList;
    },
    batchUploadHandleRemove (file, fileList) {
      this.fileList = fileList;
      this.file_name = '';
    },
    下载资质 () {
      window.open(this.$util.getURLLocalHost(this.查询批次报告表单.FILE_PATH), 'file');
    },
    batchUploadBatchReport () {
      const params = {
        DETAIL_ID_LIST: this.uploadDetailList,
        FILE_URL: this.fileList.map((item) => item.response.file_name),
        SUBMIT_UNIT: this.batchUploadBatchForm.SUBMIT_UNIT,
        TEST_UNIT: this.batchUploadBatchForm.TEST_UNIT,
      };
      batchUploadBatchReport(params).then(() => {
        this.$message.show({ text: '批量上传批次报告成功', type: 'success' });
        this.batchUploadBatchVisible = false;
        this.fileList = [];
        this.batchUploadBatchForm = [];
        this.batchUploadHandleRemove();
        this.getOrderDetailList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openBatchUploadDialog () {
      if (this.uploadDetailList[0]) {
        this.batchUploadBatchVisible = true;
      } else {
        this.$message.show({ text: '请先勾选要批量上传批次报告的商品', type: 'warning' });
      }
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  min-height: 50px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 16px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/confirmOrderDetail.vue